import { useEffect, useState } from "react";
import { Trash, Warning } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

export const DemoPurge = () => {
  const { logout } = useAuth();
  const [present, setPresent] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [purging, setPurging] = useState(false);

  useEffect(() => {
    api.get("/admin/demo-status")
      .then(({ data }) => setPresent(data.demo_present))
      .catch(() => {});
  }, []);

  const purge = async () => {
    setPurging(true);
    try {
      const { data } = await api.post("/admin/purge-demo");
      toast.success("Demo accounts and data deleted");
      if (data.status === "purged") {
        await logout();
        window.location.href = "/register?as=coach";
      } else {
        setPresent(false);
        setConfirmOpen(false);
      }
    } catch (_e) {
      toast.error("Purge failed — only the owner can do this");
      setPurging(false);
    }
  };

  if (!present) return null;

  return (
    <section className="card-flat p-6 border !border-red-500/30" data-testid="demo-purge-section">
      <div className="flex items-center gap-3 mb-3">
        <Warning size={20} weight="duotone" className="text-red-400" />
        <div>
          <h2 className="font-display text-xl">Demo data</h2>
          <p className="tracker text-zinc-500 text-[10px]">Demo accounts are still on this system</p>
        </div>
      </div>
      <p className="text-xs text-zinc-500 mb-4">
        Permanently delete the demo accounts (trainer@vital.com, client@vital.com and all their sessions, invoices, check-ins, and data).
        If you're logged in as a demo account you'll be signed out — then register your real coach account.
      </p>
      <button onClick={() => setConfirmOpen(true)} className="btn-ghost !py-2 !px-4 !text-xs !border-red-500/40 !text-red-400 hover:!bg-red-500/10" data-testid="demo-purge-btn">
        <Trash size={14} className="inline mr-1.5 -mt-0.5" /> Delete demo accounts & data
      </button>

      <Dialog open={confirmOpen} onOpenChange={(o) => { if (!purging) setConfirmOpen(o); }}>
        <DialogContent className="bg-zinc-950 border-zinc-800 text-zinc-100" data-testid="demo-purge-confirm-modal">
          <DialogHeader>
            <DialogTitle className="font-display text-xl">Delete all demo data?</DialogTitle>
            <DialogDescription className="text-zinc-400 text-sm">
              This permanently removes the demo trainer + client accounts and everything they own. This cannot be undone.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <button onClick={() => setConfirmOpen(false)} disabled={purging} className="btn-ghost !py-2 !px-4 !text-xs" data-testid="demo-purge-cancel">Cancel</button>
            <button onClick={purge} disabled={purging} className="btn-primary !py-2 !px-4 !text-xs !bg-red-600 hover:!bg-red-500" data-testid="demo-purge-confirm">
              {purging ? "Deleting…" : "Yes, delete everything"}
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </section>
  );
};
